import * as React from 'react'

import {
  InitialParentSignUpForm,
  InitialParentSignUpFormSSO,
} from 'main/components/common/AuthModal'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { Text } from 'main/ui'
import { UserSignUpSource } from 'main/util/user'
import { TextContainer } from '../GatheringRegistrationModal.styles'

interface IProps {
  schoolId: number
  onRequestLogin: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function SignUp(props: IProps) {
  const { schoolId, onRequestLogin, onComplete } = props

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  if (isSSO) {
    return (
      <InitialParentSignUpFormSSO
        source={UserSignUpSource.ParentGatheringModal}
        segmentData={{
          event: 'New Parent Lead',
          data: { schoolId },
        }}
      />
    )
  } else {
    return (
      <div>
        <TextContainer>
          <Text>Create an account to RSVP</Text>
        </TextContainer>

        <InitialParentSignUpForm
          trackingData={{ schoolId }}
          cta="Next"
          source={UserSignUpSource.ParentGatheringModal}
          onComplete={onComplete}
          onRequestLogin={onRequestLogin}
        />
      </div>
    )
  }
}
